import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/performance";
import "firebase/messaging";
require("dotenv").config();

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: "therosarians-b21de.firebaseapp.com",
  databaseURL: "https://therosarians-b21de-default-rtdb.firebaseio.com",
  projectId: "therosarians-b21de",
  storageBucket: "therosarians-b21de.appspot.com",
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  measurementId: "G-FVG5GNQVZJ",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const timestamp = firebase.firestore.FieldValue.serverTimestamp;
export { timestamp };
export default firebaseApp.firestore();
